import { catchError } from 'rxjs/operators';
import { environment as env } from './../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissaoService {

  constructor(
    private http:HttpClient
    ) { }
    public errorHandl(error: HttpErrorResponse) {
      return throwError(error.message || 'Server Error');
    }
  getBy_SiglaMatricula(SIGLA:any, MATRICULA:any): Observable<any> {
    return this.http
      .get(env.baseAuthUrl + 'api/permissao/' + SIGLA + '/' + MATRICULA);
  }
}
